var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-button',{on:{"click":function () {
        this$1.$router.go(-1);

    }}},[_vm._v(" กลับ ")]),_c('b-card-code',{attrs:{"title":"แผนที่"}},[_c('l-map',{staticStyle:{"height":"100vh"},attrs:{"zoom":_vm.zoom,"center":_vm.mapCenter}},[_c('l-tile-layer',{attrs:{"url":_vm.url}}),_vm._l((_vm.markers),function(pos,index){return _c('l-marker',{key:index,attrs:{"lat-lng":pos.gps},on:{"update:latLng":function($event){return _vm.$set(pos, "gps", $event)},"update:lat-lng":function($event){return _vm.$set(pos, "gps", $event)}}},[_c('l-popup',[_vm._v(" "+_vm._s(pos.firstname)+" ")])],1)})],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }